module.exports = "<select (change)=\"onCountryCodeChange()\" [(ngModel)]=\"selectedCountryCode\" style=\"max-width: 100%; padding: 8px;\">\n\t<option *ngFor=\"let country of allCountries; let i = index\" value=\"{{getRowValue(i)}}\">{{getCountryText(country)}}</option>\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/country-selector/country-selector.component.html
// module id = 563
// module chunks = 1